<template>
  <div>
    <h3>
      {{ $t(`${mainHeadline}`) }}
    </h3>
    <div class="row">
      <div
        v-for="(benefit, benefitIndex) in benefits"
        :key="benefitIndex"
        :class="benefitsCols"
      >
        <h4>{{ $t(`distribution:${pageKey}.listHeadlines.${benefit.headline}`) }}</h4>
        <ul>
          <li
            v-for="bulletins in benefit.bulletins"
            :key="bulletins"
            class="break-word"
          >
            {{ $t(`distribution:${pageKey}.listItems.${bulletins}`) }}
          </li>
        </ul>
      </div>
    </div>
    <logo-list
      :logo-list-data="logoListData"
    />
    <h3>{{ $t(`${workFlowHeadline}`) }}</h3>
    <content-text-icon-teaser
      :teaser-elements="registerWorkflow"
    />
  </div>
</template>

<script>
import LogoList from 'components/LogoList.vue';
import ContentTextIconTeaser from 'components/ContentTextIconTeaser.vue';
import { logosCH } from 'config/logoListConfig';



export default {
  name: 'AgencyAndDestinationImagePart',
  i18nOptions: { namespaces: 'distribution' },

  components: {
    LogoList,
    ContentTextIconTeaser,
  },
  props: {
    mainHeadline: {
      type: String,
      required: true,
    },
    benefits: {
      type: Array,
      required: true,
    },
    benefitsCols: {
      type: String,
      required: true,
    },
    workFlowHeadline: {
      type: String,
      required: true,
    },
    workflowTexts: {
      type: Object,
      required: true,
    },
    pageKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logoListData: logosCH,

    };
  },
  computed: {
    registerWorkflow() {
      return [
        {
          head: 'distribution:agency.workflow.contact',
          html: 'distribution:agency.workflow.contactTxt',
          icon: 'icon-agency-contact',
          iconClass: 'icon-v',
        },
        {
          head: 'distribution:agency.workflow.response',
          html: 'distribution:agency.workflow.responseTxt',
          icon: 'icon-agency-answer',
          iconClass: 'icon-v',
        },
        {
          head: 'distribution:agency.workflow.contractual',
          html: `distribution:${this.workflowTexts.contractualText}`,
          icon: 'icon-agency-contract',
          iconClass: 'icon-v',
        },
        {
          head: 'distribution:agency.workflow.activation',
          html: `distribution:${this.workflowTexts.actitvationText}`,
          icon: 'icon-agency-activation',
          iconClass: 'icon-v',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.break-word {
 @include hyphens;
}

</style>
